import { render, staticRenderFns } from "./company-modulr-form.vue?vue&type=template&id=b701a4fc&"
import script from "./company-modulr-form.vue?vue&type=script&lang=js&"
export * from "./company-modulr-form.vue?vue&type=script&lang=js&"
import style0 from "./company-modulr-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports